(function () {
    'use strict';
    angular.module('aprima-core-ui').factory('TransitionToHelper', [
        'ClickListenerService',
        'TransitionManager',
        '$window',
        '$rootScope',
        TransitionToHelper
    ]);

    function TransitionToHelper(
        ClickListenerService,
        TransitionManager,
        $window,
        $rootScope
    ) {
        function registerTransitionTo(scope, element, attrs, fnGetTransition) {
            element.addClass('clickable');

            var registerOpts = ClickListenerService.parseOptionsFromLink(scope, element, attrs);
            var deregister = ClickListenerService.register(element, handleClick, registerOpts);
            scope.$on('$destroy', deregister);

            function handleClick(event) {
                event.preventDefault();
                if (event.gesture && event.gesture.preventTransitions) {
                    return;
                }

                var transition = fnGetTransition();
                var transitioned = TransitionManager.transition(transition);

                if (transitioned) {
                    $rootScope.$broadcast('close-context-menu');
                    //allow click event to bubble up, but do NOT handle any other transition-to directives
                    //use the deepest occurrence to transition-to.

                    event.gesture = event.gesture || {};
                    event.gesture.preventTransitions = true;
                }
            }
        }

        return {
            registerTransitionTo: registerTransitionTo,
        };
    }
})();
